(function () {
	'use strict';

	angular
	.module('app.core')
		.directive('unauthorizedSharedView', unauthorizedSharedView);

	unauthorizedSharedView.$inject = ['storeService', '$experiments'];
	function unauthorizedSharedView(storeService, $experiments) {
		var createReactRoot = storeService.createReact18Root;
		var mountReactComponent = storeService.mountReact18Component;
		var UnauthorizedSharedView = storeService.UnauthorizedSharedView;

		return {
			template: '<div id="unauthorizedSharedView"></div>',
			restrict: 'E',
			scope: {
				type: '@'
			},
			link: function(scope, elem, attrs) {
				var rootEl = document.getElementById('unauthorizedSharedView');
				var reactRoot = createReactRoot(rootEl);
				var unmount = mountReactComponent(UnauthorizedSharedView, {type: scope.type}, reactRoot);
				
				scope.$on('$destroy', function () {
					unmount();
				});
			}
		};
	}
})();
